import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ErrorIcon from 'images/alert-square-white.svg';
import BoxList from 'layout/atoms/BoxList';
import BoxListElement from 'layout/atoms/BoxListElement';
import Button from 'layout/atoms/Button/Button';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { setCreatorActiveTab } from 'store/specificationDetailsSlice';
const problemsToTabs = {
    summary_incomplete: '/summary',
    no_size_standard: '/sizes',
    no_colors: '/color-versions',
    zero_quantity: '/production-quantities',
    no_components: '/components',
    no_product_in_component: '/components',
    no_component_consumption: '/component-consumptions',
    incomplete_variant: '/component-variants',
    incorrect_variant: '/component-variants',
    missing_variant_price: '/component-costs',
};
function SpecificationProblems({ preview = false }) {
    var _a, _b, _c, _d;
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const modalData = (_a = useSelector(selectModalByName('specificationProblems'))) === null || _a === void 0 ? void 0 : _a.data;
    const isCreator = (modalData === null || modalData === void 0 ? void 0 : modalData.creator) === true;
    const state = useSelector((state) => preview ? state.specificationPreview : state.specificationDetails);
    const id = (_b = state === null || state === void 0 ? void 0 : state.item) === null || _b === void 0 ? void 0 : _b.id;
    const problems = ((_c = state === null || state === void 0 ? void 0 : state.item) === null || _c === void 0 ? void 0 : _c.confirmationProblems) || [];
    const calculationProblems = ((_d = state === null || state === void 0 ? void 0 : state.item) === null || _d === void 0 ? void 0 : _d.estimatedCostCalculationProblems.filter((item) => item.problemType === 'missing_variant_price')) || [];
    const item = state === null || state === void 0 ? void 0 : state.item;
    const summaryProblems = [
        !(item === null || item === void 0 ? void 0 : item.fancyName) ? 'no_fancy_name' : null,
        !(item === null || item === void 0 ? void 0 : item.itemCode) ? 'no_item_code' : null,
        !(item === null || item === void 0 ? void 0 : item.brand) ? 'no_brand' : null,
        !(item === null || item === void 0 ? void 0 : item.category) ? 'no_category' : null,
        !(item === null || item === void 0 ? void 0 : item.season) ? 'no_season' : null,
        !(item === null || item === void 0 ? void 0 : item.productionTimeMinutes) ? 'no_production_time' : null,
    ].filter(Boolean);
    const renderList = (items) => (React.createElement("ul", null, items.map(({ id, nodeName }) => (React.createElement("li", { key: id }, nodeName)))));
    const getTabId = (problemType) => problemsToTabs[problemType].replace('/', '');
    const handleLinkClick = (problemType) => {
        dispatch(closeModal({ name: 'specificationProblems' }));
        if (isCreator) {
            dispatch(setCreatorActiveTab(getTabId(problemType)));
        }
    };
    const renderProblemLink = (problemType) => {
        if (isCreator) {
            return (React.createElement("button", { type: "button", onClick: () => handleLinkClick(problemType), style: {
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    color: 'inherit',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                } }, t(`${problemType}.link`)));
        }
        return (React.createElement(Link, { to: `/specifications/details/${id}${problemsToTabs[problemType]}`, onClick: () => dispatch(closeModal({ name: 'specificationProblems' })) }, t(`${problemType}.link`)));
    };
    return (React.createElement(Modal, { name: "specificationProblems", size: "m", header: React.createElement(Label, { weight: "strong" }, t('specification_problems')), subheader: React.createElement(React.Fragment, null,
            React.createElement(ErrorIcon, null),
            " ",
            t('SPECIFICATION_MISSING_INFO_MODAL_BAR')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: 'specificationProblems' })) }, t('common:close')),
            React.createElement(Button, { color: "primary", onClick: () => dispatch(closeModal({ name: 'specificationProblems' })) }, t('common:done'))) },
        React.createElement(BoxList, null,
            summaryProblems.length > 0 && (React.createElement(BoxListElement, { marker: 1, header: React.createElement(React.Fragment, null,
                    t('summary_problems.prefix'),
                    renderProblemLink('summary_incomplete'),
                    t('summary_problems.suffix')) },
                React.createElement("ul", null, summaryProblems.map((key) => (React.createElement("li", { key: key }, t(`${key}.label`))))))),
            problems.map(({ id: problemId, problemType, components, componentVariants }, index) => (React.createElement(BoxListElement, { key: problemId, marker: (summaryProblems.length > 0 ? 1 : 0) + index + 1, header: React.createElement(React.Fragment, null,
                    t(`${problemType}.prefix`),
                    renderProblemLink(problemType),
                    t(`${problemType}.suffix`)) },
                renderList(components),
                renderList(componentVariants)))),
            calculationProblems.map(({ id: problemId, problemType, components, componentVariants }, index) => (React.createElement(BoxListElement, { key: problemId, marker: (summaryProblems.length > 0 ? 1 : 0) + problems.length + index + 1, header: React.createElement(React.Fragment, null,
                    t(`${problemType}.prefix`),
                    renderProblemLink(problemType),
                    t(`${problemType}.suffix`)) },
                renderList(components),
                renderList(componentVariants)))))));
}
export default memo(SpecificationProblems);
